<template>
  <div>
    <div class="page-title">Edit Badge Form</div>
    <Form v-if="form" btnText="Update Badge" :submit="update" v-model="form" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.badges.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.Badge.update(this.form);
      this.$router.push("/badges");
    },
    async setForm() {
      const { data } = await this.$api.Badge.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
